import { EstadoSolicitud } from 'src/app/core/models/enum/estado-solicitud.enum';
import { EstadoSolicitudAntigua } from '../../models/enum/estado-solicitud-antigua-enum';


export interface EstadoHomologado {
    valor: string;
    nombre: string;
}

export class EstadoHomologacionHelper {

    private static readonly MAPA_GRUPOS: { [key: number]: string } = {
        [EstadoSolicitud.EN_PROCESO]: 'En Trámite',
        [EstadoSolicitud.EN_VALIDACION_INTERNA]: 'En Trámite',
        [EstadoSolicitud.APROBADO_PARCIAL]: 'En Trámite',
        [EstadoSolicitud.APROBADO]: 'En Trámite',
        [EstadoSolicitud.DEVOLUCION]: 'Con Observaciones',
        [EstadoSolicitud.DEVOLUCION_SUBSANADA]: 'Con Observaciones',
        [EstadoSolicitud.COMPLETADO_PARCIAL]: 'Con Observaciones',
        [EstadoSolicitud.RECHAZADO]: 'Rechazado',
        [EstadoSolicitud.COMPLETADO]: 'Aprobado',
        [EstadoSolicitud.COMPLETADO_MANUAL]: 'Aprobado'
    };

    private static readonly MAPA_GRUPOS_ANTIGUOS: { [key: number]: string } = {
        [EstadoSolicitudAntigua.PENDING]: 'En Trámite',
        [EstadoSolicitudAntigua.DEVOLUTION]: 'Rechazado',
        [EstadoSolicitudAntigua.APPROBATION]: 'Aprobado',
        [EstadoSolicitudAntigua.DUPLICIDAD]: 'Rechazado',
        [EstadoSolicitudAntigua.BLOQUEO_SAP]: 'En Trámite',
        [EstadoSolicitudAntigua.APROBADO_PARCIAL]: 'Aprobado',
        [EstadoSolicitudAntigua.APROBADO_MANUAL]: 'Aprobado',
        [EstadoSolicitudAntigua.ACTUALIZACION_OPERATIVA]: 'Rechazado',
        [EstadoSolicitudAntigua.RECHAZADO]: 'Rechazado',
    }

    public static obtenerNombreGrupo(codigo: number | string): string {
        // Si es nulo, indefinido o string vacío, devolvemos un guion o vacío
        if (codigo === null || codigo === undefined || codigo === '') {
            return 'Sin Estado';
        }
        const numCodigo = Number(codigo);
        // Si el número no está en nuestro mapa, devolvemos el mismo mensaje
        return this.MAPA_GRUPOS[numCodigo] || 'Sin Estado';
    }

    public static obtenerNombreGrupoHomologado(codigo: number | string, row: any): string {
        // Si es nulo, indefinido o string vacío, devolvemos un guion o vacío
        if (codigo === null || codigo === undefined || codigo === '') {
            return 'Sin Estado';
        }
        const numCodigo = Number(codigo);
        if (row?.nuevo !== undefined && row?.nuevo == true) {
            // Si el número no está en nuestro mapa, devolvemos el mismo mensaje
            return this.MAPA_GRUPOS[numCodigo] || 'Sin Estado';
        } else {
            return this.MAPA_GRUPOS_ANTIGUOS[numCodigo] || 'Sin Estado';
        }
    }

    public static obtenerOpcionesFiltro(): EstadoHomologado[] {
        return [
            { valor: 'En Trámite', nombre: 'En Trámite' },
            { valor: 'Con Observaciones', nombre: 'Con Observaciones' },
            { valor: 'Rechazado', nombre: 'Rechazado' },
            { valor: 'Aprobado', nombre: 'Aprobado' }
        ];
    }
}
